import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { AgentThread } from '../api/agent';
import { useApiServices } from '../api/services';
import { agentThreadsKey } from '../components/agent/agent-query-keys';
import { useAuth } from './useAuth';

export function useAgentConversations() {
  const { agent } = useApiServices();
  const { organization } = useAuth();
  const queryClient = useQueryClient();
  const key = agentThreadsKey(organization?.id);

  const query = useQuery({
    queryKey: key,
    queryFn: () => agent.listThreads(),
    enabled: !!organization?.id,
    staleTime: 15_000,
  });

  const invalidate = () => void queryClient.invalidateQueries({ queryKey: key });

  const archive = useMutation({
    mutationFn: (threadId: string) => agent.deleteThread(threadId),
    onSuccess: invalidate,
  });

  return {
    threads: (query.data ?? []) as AgentThread[],
    isLoading: query.isLoading,
    archive,
  };
}
